// src/components/DownloadButton.jsx
import { Download } from "lucide-react";
import api from "../api/api"; // axios instance with JWT already

export default function DownloadButton({ id, fileName }) {
  const handleDownload = async () => {
    try {
     const res = await api.get(`/prep/${id}/download?t=${Date.now()}`, {
  responseType: "blob",
});

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName || "download");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Failed to download file");
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-1"
    >
      <Download size={14} /> Download
    </button>
  );
}
